import React from "react";

import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { DealLaScSection } from "@/types/dealLaSc.types";
import TableDragDivider from "@FillInTableContainer/shared/components/TableDragDivider/TableDragDivider";
import { useCanEditGroupTable } from "@FillInTableContainer/shared/hooks/useCanEditGroupTable";
import useCheckIsDisplayTableDragDivider from "@FillInTableContainer/shared/hooks/useCheckIsDisplayTableDragDivider";
import { useGetNumberOfTable } from "@FillInTableContainer/shared/hooks/useGetNumberOfTable";
import { useHandleTableCreatorTableDrag } from "@FillInTableContainer/shared/hooks/useHandleTableCreatorTableDrag";
import { TableCreatorSubGroupTableList } from "@FillInTableContainer/shared/types/tableCreator.types";
import { newArrayToCountValue } from "@utils/newArrayToCountValue";

import DealLaScFinancialTermsTable from "./components/DealLaScFinancialTermsTable/DealLaScFinancialTermsTable";
import * as S from "./DealLaScFinancialTermsGroupTable.style";

interface Props {
  groupTableKey: DealLaScSection;
  tableList: TableCreatorSubGroupTableList;
  groupTableIndex: number;
  customTableDeleteEvent?: () => void;
}

const DealLaScFinancialTermsGroupTable = ({
  groupTableIndex,
  groupTableKey,
  tableList,
  customTableDeleteEvent,
}: Props) => {
  const articleSection = ENTRY_DATA_SECTION_KEYS.dealsLaSc;
  const { tableCount } = useGetNumberOfTable(articleSection);

  const { checkDisableEdit } = useCanEditGroupTable(articleSection);

  const { handleDragOver, draggedIndexInfo, isDraggingTable } =
    useHandleTableCreatorTableDrag(articleSection);
  const { isLastTable, handleCheckDragDividerDisplay } =
    useCheckIsDisplayTableDragDivider();

  return (
    <S.TableCreatorTableListWrapper
      isDisableEdit={checkDisableEdit(groupTableKey)}
    >
      {tableList.map(({ tableKey, groupShellSectionList }) => {
        return newArrayToCountValue(tableCount(groupTableKey)).map(
          (_, multiTableIndex) => {
            return (
              <S.DraggableTableWrapper
                key={`table-${String(groupTableIndex)}-${String(
                  multiTableIndex,
                )}`}
                isTargetDraggingTable={
                  isDraggingTable && draggedIndexInfo[0] !== multiTableIndex
                }
                onDragOver={(e) => handleDragOver(e, multiTableIndex)}
              >
                <TableDragDivider
                  isDraggingEndPosition={handleCheckDragDividerDisplay({
                    moveDragIndex: draggedIndexInfo[1],
                    startDragIndex: draggedIndexInfo[0],
                    tableIndex: multiTableIndex,
                    currentGroupTableKey: groupTableKey,
                    isDraggingTable,
                  })}
                />
                <DealLaScFinancialTermsTable
                  key={`table-${String(groupTableIndex)}-${String(
                    multiTableIndex + 1,
                  )}`}
                  tableKey={tableKey}
                  groupShellSectionList={groupShellSectionList}
                  groupTableKey={groupTableKey}
                  groupTableIndex={groupTableIndex}
                  tableIndex={multiTableIndex}
                  tableCount={tableCount(groupTableKey)}
                  customTableDeleteEvent={customTableDeleteEvent}
                />
                {isLastTable(multiTableIndex, groupTableKey) && (
                  <TableDragDivider
                    isDraggingEndPosition={handleCheckDragDividerDisplay({
                      moveDragIndex: draggedIndexInfo[1],
                      startDragIndex: draggedIndexInfo[0],
                      tableIndex: multiTableIndex,
                      currentGroupTableKey: groupTableKey,
                      isDraggingTable,
                      lastIndex: newArrayToCountValue(tableCount(groupTableKey))
                        .length,
                    })}
                  />
                )}
              </S.DraggableTableWrapper>
            );
          },
        );
      })}
    </S.TableCreatorTableListWrapper>
  );
};

export default DealLaScFinancialTermsGroupTable;
